import React from 'react'
import { Provider } from './Context'
import { Layout } from './Layout'

export const AdvanceFilterMenuItem = (props) => {
  return (
    <Provider {...props}>
      <Layout />
    </Provider>
  )
}
